/* unplugin-vue-components disabled */import { render } from "./AdvertiseSwipe.vue?vue&type=template&id=bd6539f2&scoped=true"
import script from "./AdvertiseSwipe.vue?vue&type=script&lang=js"
export * from "./AdvertiseSwipe.vue?vue&type=script&lang=js"

import "./AdvertiseSwipe.vue?vue&type=style&index=0&id=bd6539f2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6539f2"]])

export default __exports__